import React, { forwardRef } from "react";
import "./Input.scss";

const Input = forwardRef((props, ref) => {
  const { error, ...rest } = { ...props };

  return (
    <div className="input-container">
      <input ref={ref} {...rest} />
      {error?.length > 0 && <p>{error}</p>}
    </div>
  );
});

export default Input;
